export default {
  install: Vue => {
    // Vue.component('modal', require('./modal').default)
    Vue.component('modal-form', require('./modal-form').default)
  },
}
